import Layout from 'antd/lib/layout';
import React from 'react';
import { useOverscrollBehaviorFix } from './useOverscrollBehaviorFix';
import './sidebarWrapper.css';

interface ISidebarWrapperProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    children: React.ReactNode;
    collapsedWidth: number;
    expandedWidth: number;
}

export const SidebarWrapper: React.FC<ISidebarWrapperProps> = ({ children, collapsed, onCollapseChange, collapsedWidth, expandedWidth }) => {
    useOverscrollBehaviorFix();

    return (
        <Layout.Sider
            collapsible
            theme="light"
            collapsedWidth={collapsedWidth}
            width={expandedWidth}
            collapsed={collapsed}
            onCollapse={onCollapseChange}
            style={{
                background: collapsed ? 'var(--ant-color-primary)' : 'white',

                position: 'fixed',
                left: 0,
                top: 64,
                bottom: 0,
                zIndex: 1000,

                // Disable collapse animation
                transition: 'none',

                borderTop: `1px solid #d9d9d9`,
                boxShadow: '5px 2px 5px rgba(0, 0, 0, 0.15)',
            }}
            trigger={null}
        >
            {children}
        </Layout.Sider>
    );
};
